module.exports = __webpack_public_path__ + "static/media/whitelogo.a079f841.png";